import axios from 'axios';
import endpointNames from "../configs/serverUrls";

//url variables
const baseUrl = endpointNames.policyHolder;
// get User Token
let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//get all policy holders

const getAllPolicyHolders = async () => {

    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    //include the config in your request

    await axios.get(baseUrl + 's', config)
        .then(res => {
            console.log("res: ", res);
                response = res;


        }).catch(err => {
            console.log("err: ",err.status);
            response = [];
        });

    return response;
}

//add policy holder
const savePolicyHolder = async(d) => {
    let response;
    console.log(d)

    let data = {
        "title": d.title,
        "first_name": d.first_name,
        "last_name": d.last_name,
        "date_of_birth": d.date_of_birth,
        "id_number": d.id_number,
        "gender": d.gender,
        "work_telephone": d.work_telephone,
        "mobile": d.mobile,
        "email": d.email,
        "ec_number": d.ec_number,
        "aggregator_id": d.aggregator_id,
        "occupation": d.occupation,
        "smoker_status": d.smoker_status,
        "salary": d.salary,
        "physical_address_city": d.physical_address_city,
        "physical_address_street": d.physical_address_street,
        "physical_address_suburb": d.physical_address_suburb,
        "postal_address_city": d.postal_address_city,
        "postal_address_street": d.postal_address_street,
        "postal_address_suburb": d.postal_address_suburb,
        "status": d.status,


    }

    console.log("data: ", data);

    await axios.post(baseUrl,data, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log("server response: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error: ", err.message, " 2: ", err.response);
            response = err.response;
        });
    return response;
}

//update policy holder
const updatePolicyHolder = async (d) => {
    let response;
    console.log("request: ",d);

    let data = {
        "id": d.id,
        "title": d.title,
        "first_name": d.first_name,
        "last_name": d.last_name,
        "date_of_birth": d.date_of_birth,
        "id_number": d.id_number,
        "gender": d.gender,
        "work_telephone": d.work_telephone,
        "mobile": d.mobile,
        "email": d.email,
        "ec_number": d.ec_number,
        "aggregator_id": d.aggregator_id,
        "occupation": d.occupation,
        "physical_address_street": d.physical_address_street,
        "physical_address_suburb": d.physical_address_suburb,
        "physical_address_city": d.physical_address_city,
        "postal_address_street": d.postal_address_street,
        "postal_address_suburb": d.postal_address_suburb,
        "postal_address_city": d.postal_address_city,
        "smoker_status": d.smoker_status,
        "salary": parseInt(d.salary),
        "clientType": "SSB",
        "status": d.status
    }

    //url should be baseUrl + '/update/'+ d.policyHolderId
    await axios.put(baseUrl + '/update/' + d.id, data, {
        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;

}

//delete policy holder
const deletePolicyHolder = async (id) => {
    let response;

    await axios.delete(baseUrl + '/' + id, {
        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}



//get policy holder details
const getPolicyHolder = async (id) => {
    let response;
    let token = JSON.parse(localStorage.getItem('token'));
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(baseUrl+'/'+id, config)
        .then(res => {
            console.log("server response: ", res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


export default {
    getAllPolicyHolders,
    deletePolicyHolder,
    savePolicyHolder,
    getPolicyHolder,
    // getPolicyHolderAccident,
    // getPolicyHolderComprehensive,
    // getPolicyHolderFuneral,
    // getPolicyHolderSavings,
    updatePolicyHolder
}
